import type { FTFindEvents, HistoricEventData } from "../types/ftfind";

import { FTFIND_EVENT } from "../types/ftfind/constants";
import { SQRL_EVENT } from "../types/sqrl/constants";

export class FTFindHistoryEvent {
  static register(event: HistoricEventData) {
    if (event && event.historic) {
      return;
    }

    window.o_global.events<FTFindEvents>().emit(FTFIND_EVENT.MERGE, {
      topic: SQRL_EVENT.SEARCH_CLOSE,
      data: { historic: true },
    });

    /*                                               */
    window.o_global.events<FTFindEvents>().emit(FTFIND_EVENT.PUSH, {
      topic: SQRL_EVENT.SEARCH_OPEN,
      data: { historic: true },
    });
  }

  static remove(event: HistoricEventData) {
    if (event && event.historic) {
      return;
    }
    window.o_global.events<FTFindEvents>().emit(FTFIND_EVENT.SHIFT);
  }
}
